// Module
var code = "<a ng-href={{$ctrl.url}} target=_blank ng-click=$event.stopPropagation()> <i class=\"fab fa-facebook-square\"></i> </a> ";
// Exports
module.exports = code;